<template>
  <CTable
    :columns="columns"
    :data="data"
    :total="total"
    :current="current"
    :show-page="true"
    :page-size="pageSize"
    @change="change"
  />
</template>

<script>
import CTable from '@/components/CTable'
import {createColumns} from './interface'
export default {
  name: 'List',
  components: {
    CTable
  },
  props: {
    data: {
      type: Array,
      default: () => {
        return []
      }
    },
    total: Number,
    current: Number,
    change: Function,
    pageSize:Number
    
  },
  data () {
    return {
      columns: createColumns({
        editDetail: this.editDetail,
        deleteAction: this.deleteAction,
        toDetail: this.toDetail
      }),
    }
  },
  methods: {
    deleteAction (p) {
      this.$emit('on-delete',p)
    },
    editDetail (p) {
      this.$emit('on-edit',p)
    },
    toDetail (p) {
      this.$emit('on-detail',p)
    }
  }
}
</script>
